export default __webpack_public_path__ + "static/media/Logo_APMF.42aedbc3.png";